import { render, staticRenderFns } from "./ScrollHint.vue?vue&type=template&id=f10a6cd2&scoped=true"
import script from "./ScrollHint.vue?vue&type=script&lang=js"
export * from "./ScrollHint.vue?vue&type=script&lang=js"
import style0 from "./ScrollHint.vue?vue&type=style&index=0&id=f10a6cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10a6cd2",
  null
  
)

export default component.exports